/* @flow */

export const SEM_REFERENCIA = 'Sem ponto de referência';
export const SEM_COMPLEMENTO = 'Sem complemento';
export const RETIRADA_NO_LOCAL = 'RETIRADA NO LOCAL';
export const ENDERECO_SEM_NOME = 'Sem nome cadastrado';
